import type {PageRouteConfig} from '@router';

import ExtraDeliveryDetails from 'modules/Services/PromotionCenter/ExtraDelivery/Details/ExtraDeliveryDetails';

export function createPromotionCenterExtraDeliveryDetailsRoute(): PageRouteConfig {
  return {
    element: <ExtraDeliveryDetails />,
    layout: {
      title: 'جزئیات محدوده پوشش‌دهی',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1,
      headerDataKey: 'extraDeliveryDetails'
    },
    initialHeaderData: {
      extraDeliveryDetails: {icon: '', iconTitle: '', action: null, title: ''}
    }
  };
}
